@let notifi = notification();

@if (!componentRef) {
  <div style="border: 1px solid red">
    MISSING DEFINITION FOR '{{ notifi.type }}'
  </div>
}
<div
  class="flex flex-row items-center place-content-start notification notification-content"
  [ngClass]="{ read: notifi.isRead }"
  mat-ripple
>
  <div (click)="notificationClicked($event)" class="flex flex-col">
    <ng-template notificationsNotificationHost></ng-template>
  </div>
</div>
<div class="divider"></div>
